module.exports = __webpack_public_path__ + "img/arrow-down-icon.50051e99.svg";